import { useState, useEffect } from 'react'

export const useCurrentUrl = () => {
  const [currentUrl, setCurrentUrl] = useState(window.location.href)

  useEffect(() => {
    const handleUrlChange = () => {
      setCurrentUrl(window.location.href)
    }

    // Attach an event listener to handle changes in the URL
    window.addEventListener('popstate', handleUrlChange)

    // Cleanup the event listener when the component unmounts
    return () => {
      window.removeEventListener('popstate', handleUrlChange)
    }
  }, []) // Empty dependency array means this effect runs once after the initial render

  return currentUrl
}
